/* WOD.LOL — « Complète ton look » + bandeau d'offres (fiche produit).
   Chargé par snippets/wl-look.liquid et snippets/wl-offers.liquid (garde anti double-exécution). */
(function () {
  'use strict';
  if (window.__wlLook) return;
  window.__wlLook = true;

  function variantsOf(card) {
    var el = card.querySelector('[data-wl-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function sync(card) {
    var btn = card.querySelector('[data-wl-look-add]');
    var selects = card.querySelectorAll('.wl-look__select');
    if (!btn || !selects.length) return;
    var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
    var match = variantsOf(card).filter(function (v) {
      return v.o.every(function (o, i) { return o === chosen[i]; });
    })[0];
    var ok = !!(match && match.a);
    btn.disabled = !ok;
    var label = btn.querySelector('.wl-look__add-label');
    if (label) label.textContent = ok ? (document.documentElement.lang === 'en' ? 'Add' : 'Ajouter') : (document.documentElement.lang === 'en' ? 'Sold out' : 'Épuisé');
    if (match) btn.dataset.variantId = match.id;
    var img = card.querySelector('.wl-look__media img');
    if (match && match.i && img && img.getAttribute('src') !== match.i) {
      img.removeAttribute('srcset');
      img.setAttribute('src', match.i);
    }
  }

  // Taille choisie sur la fiche → appliquée aux suggestions (si l'utilisateur n'y a pas touché).
  function currentSize(box) {
    var idx = parseInt(box.dataset.sizeIndex, 10);
    if (isNaN(idx) || idx < 0) return null;
    var el = document.querySelector('variant-selects [data-selected-variant]');
    if (!el) return null;
    try {
      var v = JSON.parse(el.textContent);
      return v && v.options ? v.options[idx] : null;
    } catch (e) { return null; }
  }

  function applySize(box) {
    var size = currentSize(box);
    box.querySelectorAll('.wl-look__card').forEach(function (card) {
      if (size) {
        card.querySelectorAll('.wl-look__select').forEach(function (s) {
          if (s.dataset.touched) return;
          if (s.dataset.name !== 'taille' && s.dataset.name !== 'size') return;
          var prev = s.value;
          s.value = size;
          if (s.value !== size) { s.value = prev; return; }
          sync(card);
          var btn = card.querySelector('[data-wl-look-add]');
          if (btn && btn.disabled) { s.value = prev; }
        });
      }
      sync(card);
    });
  }

  function init() {
    document.querySelectorAll('.wl-look').forEach(applySize);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.classList && t.classList.contains('wl-look__select')) {
      t.dataset.touched = '1';
      sync(t.closest('.wl-look__card'));
      return;
    }
    if (t.closest && t.closest('variant-selects')) {
      // Dawn re-rend le bloc variante : on relit la taille un peu après.
      setTimeout(init, 450);
    }
  });

  document.addEventListener('click', function (e) {
    var copy = e.target.closest && e.target.closest('[data-wl-copy]');
    if (copy) {
      var code = copy.dataset.wlCopy;
      var label = copy.querySelector('[data-wl-copy-label]');
      var done = function () {
        copy.classList.add('is-copied');
        if (label) label.textContent = document.documentElement.lang === 'en' ? 'Copied!' : 'Copié !';
        setTimeout(function () { copy.classList.remove('is-copied'); if (label) label.textContent = code; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else done();
      return;
    }

    var btn = e.target.closest && e.target.closest('[data-wl-look-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { _wl_source: 'look' } }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || !res.sections) throw new Error(res.description || 'add failed');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; }, 1600);
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
